/* LDF Sala — JS globale minimo */
(function(){
  var nav=document.querySelector('.ldf-nav');
  var tg=document.querySelector('.ldf-nav-toggle');
  if(tg&&nav){tg.addEventListener('click',function(){nav.classList.toggle('open');tg.setAttribute('aria-expanded',nav.classList.contains('open'))});}
  if(document.querySelector('.ldf-sticky')){document.body.classList.add('has-sticky');}
  var pref=document.getElementById('ldf-cookie-prefs');
  if(pref){pref.addEventListener('click',function(){
    if(window.privacyBanner&&window.privacyBanner.showPreferences){window.privacyBanner.showPreferences();return;}
    if(window.Shopify&&window.Shopify.customerPrivacy&&window.Shopify.customerPrivacy.showPreferences){window.Shopify.customerPrivacy.showPreferences();return;}
    window.location.href='/pages/cookie-policy';
  });}
  window.ldfTrack=function(name,params){window.dataLayer=window.dataLayer||[];var p=params||{};p.event=name;window.dataLayer.push(p);};
  document.addEventListener('click',function(e){var el=e.target.closest('[data-ldf-event]');if(el){window.ldfTrack(el.getAttribute('data-ldf-event'),{label:el.getAttribute('data-ldf-label')||''});}});
})();
